import { Dimensions } from 'components/insights/constants';

import { NetworkPerformanceMetricDrillKey, NetworkPerformanceMetrics } from './constants';

// --- Patient list configs ---

export type PatientListConfig = {
  dateColumnHeader: string;
  patientListGroupDimension: Dimensions;
  patientListDateDimension?: Dimensions;
  patientListExtraDimensions?: { dimension: Dimensions; header: string; format: (v: string) => string }[];
  patientListDefaultSortId?: string;
  patientListTitle?: string;
};

const M = NetworkPerformanceMetrics;

export const PATIENT_LIST_CONFIGS: Record<NetworkPerformanceMetricDrillKey, PatientListConfig> = {
  [M.AVG_START_OF_CARE]: {
    dateColumnHeader: 'Admission Date',
    patientListGroupDimension: Dimensions.GROUP,
  },
  [M.SERVICE_REFUSALS]: {
    dateColumnHeader: 'Service Refusal Date',
    patientListGroupDimension: Dimensions.GROUP,
  },
  [M.SAFE_RETURNS]: {
    dateColumnHeader: 'Safe Return Requested Date',
    patientListGroupDimension: Dimensions.GROUP,
  },
  [M.OES]: {
    dateColumnHeader: 'Discharge Date',
    patientListGroupDimension: Dimensions.GROUP_NAME,
  },
  [M.READMISSION_RATE]: {
    dateColumnHeader: 'Readmission Date',
    patientListGroupDimension: Dimensions.GROUP_NAME,
    patientListDateDimension: Dimensions.READMISSION_DATE,
    patientListExtraDimensions: [
      { dimension: Dimensions.LENGTH_OF_STAY, header: 'Length of Service', format: (v) => `${v} days` },
    ],
    patientListDefaultSortId: Dimensions.LENGTH_OF_STAY,
    patientListTitle: 'Readmitted Patients',
  },
  [M.ENGAGEMENTS]: {
    dateColumnHeader: 'Discharge Date',
    patientListGroupDimension: Dimensions.GROUP_NAME,
  },
};
